import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <>
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/daf098e6ebd9c4ebc13710c19d4107e6.jpg"
            alt="Modern web design workspace"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a]/90 via-[#111111]/75 to-[#111111]/40" />
        </div>

        {/* Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-20">
          <div className="max-w-2xl">
            <span className="inline-block text-accent font-semibold text-xs uppercase tracking-[0.2em] mb-5">
              Web Design Agency
            </span>

            <h1 className="font-heading text-5xl md:text-7xl font-bold text-white leading-[1.08] mb-6">
              Small Business
              <br />
              <span className="text-accent">Websites</span>
            </h1>

            <p className="text-xl md:text-2xl text-white/80 font-light mb-4 leading-relaxed">
              Affordable, effective small business websites
            </p>

            <p className="text-white/60 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
              We build <strong className="text-white/80">professional business websites</strong> that help you get more customers, rank higher on Google, and grow your business — without the agency price tag.
            </p>

            {/* Pricing badge */}
            <div className="inline-flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-6 py-4 mb-10">
              <div>
                <p className="text-white/60 text-xs uppercase tracking-widest mb-0.5"></p>
                <p className="font-heading text-4xl font-bold text-white leading-none">£149<span className="text-accent">.</span><span className="text-2xl">00</span></p>
              </div>
              <div className="w-px h-12 bg-white/20" />
              <div>
                <p className="text-white/80 text-sm font-medium leading-snug">Complete website</p>
                <p className="text-white/50 text-xs mt-0.5">Up to 5 pages included</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 bg-accent hover:bg-accent-dark text-white font-semibold px-8 py-4 rounded-lg text-base transition-all duration-200 cursor-pointer shadow-lg shadow-orange-500/25 hover:shadow-orange-500/40"
              >
                Get Started — £149
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </Link>
              <Link
                to="/portfolio"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 border-2 border-white/40 hover:border-white text-white font-semibold px-8 py-4 rounded-lg text-base transition-all duration-200 cursor-pointer backdrop-blur-sm hover:bg-white/10"
              >
                View Our Work
              </Link>
            </div>

            {/* Trust signals */}
            <div className="flex flex-wrap gap-6 mt-12">
              {[
                { icon: "ri-star-fill", text: "5-Star Rated" },
                { icon: "ri-shield-check-line", text: "100+ Websites Built" },
                { icon: "ri-time-line", text: "14-Day Turnaround" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2 text-white/60 text-sm">
                  <span className="w-5 h-5 flex items-center justify-center text-accent">
                    <i className={item.icon} />
                  </span>
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 animate-bounce">
          <span className="text-xs uppercase tracking-widest">Scroll</span>
          <i className="ri-arrow-down-line text-lg" />
        </div>
      </section>
    </>
  );
}
